export default "__VITE_ASSET__DmnREk5F__"